<template>
  <div>
    <popup2 v-model="showPopup" width="428" @click:outside="handleClose">
      <template v-if="typeAction === 'edit-rights'">
        <v-card>
          <v-card-title class="primary--text pa-4">
            Edit rights
          </v-card-title>
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            v-model="popupValue"
            item-value="id"
            item-text="name"
            :items="getRights()"
            return-object
            class="px-4"
          ></v-select>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="handleClose">Cancel</v-btn>
            <v-btn color="primary" text @click="changeRights">Apply</v-btn>
          </v-card-actions>
        </v-card>
      </template>
      <template v-else-if="typeAction === 'add-object'">
        <v-card>
          <v-card-title class="primary--text pa-4">
            Link existing object
          </v-card-title>
          <v-text-field
            v-model="popupValue"
            label="Object UUID"
            clearable
            class="px-4"
          ></v-text-field>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="handleClose">Cancel</v-btn>
            <v-btn
              text
              color="primary"
              @click="connectObject"
              :loading="popupLoading"
              >Link</v-btn
            >
          </v-card-actions>
        </v-card>
      </template>
      <default-confirmation
        v-else-if="typeAction === 'delete'"
        :loading="popupLoading"
        @close="handleClose"
        @delete="deleteEntity"
      />
      <remove-confirmation
        v-else-if="typeAction === 'remove'"
        :loading="popupLoading"
        @close="handleClose"
        @remove="disconnectObject(currentContext)"
      />
      <execute-method
        v-else-if="typeAction === 'execute-control'"
        :loading="popupLoading"
        :context="currentContext"
        @save="executeControl"
        @close="handleClose"
      />
      <send-noty
        :name="entity.title"
        v-else-if="typeAction === 'send-noty'"
        @close="handleClose"
        :loading="popupLoading"
      />
      <edit-rights-group
        v-else-if="typeAction === 'change-group-access'"
        :entity="currentContext.raw || objectItem.data.object"
        :loading="popupLoading"
        @save="changeGroupRights"
        @close="handleClose"
      />
      <default-confirmation
        v-else-if="typeAction === 'set-property-default'"
        text-delete="Set property default?"
        action-name="set"
        :loading="popupLoading"
        @close="handleClose"
        @delete="setPropertyDefault"
      />
      <default-confirmation
        v-else-if="typeAction === 'set-property-null'"
        :loading="popupLoading"
        action-name="set"
        text-delete="Set property null?"
        @close="handleClose"
        @delete="setPropertyNull"
      />
    </popup2>
    <portal-target name="nested">
      <app-entity
        :is-nested-entity="isNestedEntity"
        :current-show="currentShow"
        :type-action="typeAction"
        :entity="entity"
        :loading="loading"
        :nested-entity="nestedEntity"
        :context="currentContext"
        :object="objectItem"
        :tab-data="logsList"
        @close-card="closeCard"
        @favourite-action="toggleFavorite"
        @action="handleAction"
        @show-nested-entity="showNestedEntity"
        @close-history="closeHistory"
        @close-nested-card="closeNestedCard"
        @show-full-logs="showFullLogs"
      />
    </portal-target>
  </div>
</template>

<script>
import useSchedule from '@/api/schedules/useSchedule';
import { onMounted, watch } from '@vue/composition-api';
import DefaultConfirmation from '@/components/app-entity/modals/DefaultConfirmation';
import RemoveConfirmation from '@/components/app-entity/modals/RemoveConfirmation';
import ExecuteMethod from '@/components/app-entity/modals/ExecuteMethod';
import { Wormhole } from 'portal-vue';

export default {
  name: 'DatasetItem',
  props: ['id', 'isNestedEntity'],
  components: {
    DefaultConfirmation,
    RemoveConfirmation,
    ExecuteMethod,
    SendNoty: () => import('@/components/app-entity/modals/SendNoty'),
    EditRightsGroup: () =>
      import('@/components/app-entity/modals/EditRightsGroup')
  },
  setup(props, context) {
    const entityComposition = useSchedule(props, context);

    const closeCard = () => {
      entityComposition.entity.value = null;
      context.root.$router.push({
        name: context.root.$route.meta.rootRouteName,
        query: context.root.$route.query
      });
    };

    onMounted(() => {
      entityComposition.load();
    });

    return {
      ...entityComposition,
      closeCard
    };
  }
};
</script>
